import { useGetTradeInConfiguration } from "./useGetTradeInConfiguration";
export const useTradeInConfiguration = () => {
    const { data, isLoading } = useGetTradeInConfiguration();
    const onlineData = data === null || data === void 0 ? void 0 : data.online;
    return {
        isLoading,
        isUsingRegisteredDevices: onlineData ? !onlineData.requiredDevice : undefined,
        defaultDevices: onlineData === null || onlineData === void 0 ? void 0 : onlineData.supportedModels,
    };
};
//# sourceMappingURL=useTradeInConfiguration.js.map